import React from 'react';

const Card = ({ children, level }) => {
  let levelClasses = 'border-gray-400';
  if (level === 'error') levelClasses = 'border-red-500 bg-red-100';
  if (level === 'success') levelClasses = 'border-green-500 bg-green-100';
  return <div className={`p-8 shadow-lg border w-1/3 bg-white ${levelClasses}`}>{children}</div>;
};

export default Card;
